import React from 'react'
import { RoadmapItem, RoadmapLabel } from '../../services/projetos'

export const ItemCard: React.FC<{ item: RoadmapItem; labelsMap?: Record<string, RoadmapLabel> }> = ({ item, labelsMap }) => {
  const pill = (text: string, colorClass: string) => (
    <span className={`px-2 py-0.5 text-[11px] rounded-full ${colorClass}`}>{text}</span>
  )
  const statusColor: Record<string,string> = {
    ideia: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
    planejado: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
    em_andamento: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
    concluido: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300',
    bloqueado: 'bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300'
  }
  const fmt = (d?: string | null) => d ? new Date(d).toLocaleDateString() : '—'

  return (
    <div className="rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-3 shadow-sm">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="text-sm font-medium text-gray-900 dark:text-white truncate">{item.title}</div>
          {item.description && (
            <div className="text-xs text-gray-500 dark:text-gray-400 truncate">{item.description}</div>
          )}
        </div>
        {pill(item.status.replace('_',' '), statusColor[item.status])}
      </div>
      <div className="mt-2 flex items-center gap-2 text-[12px] text-gray-600 dark:text-gray-300">
        <span>Início: {fmt(item.start_date)}</span>
        <span>•</span>
        <span>Fim: {fmt(item.end_date)}</span>
      </div>
      {!!item.label_ids?.length && (
        <div className="mt-2 flex flex-wrap gap-1.5">
          {item.label_ids.map(id => {
            const l = labelsMap?.[id]
            if (!l) return null
            const labelColor = (l.color && l.color.trim()) ? l.color.trim() : '#3b82f6'
            return (
              <div
                key={id}
                className="flex items-center gap-1.5 px-2 py-0.5 rounded-md border border-gray-200 dark:border-gray-700"
                style={{ backgroundColor: 'transparent' }}
              >
                <div
                  className="w-4 h-4 rounded border-2 flex-shrink-0"
                  style={{ 
                    backgroundColor: labelColor,
                    borderColor: labelColor,
                    minWidth: '16px', 
                    minHeight: '16px' 
                  }}
                />
                <span className="text-[11px] text-gray-700 dark:text-gray-300">{l.name}</span>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default ItemCard


